export const pathname = `/mobility/browse`;

export enum Brand {
    DBA = "dba",
    FINN = "finn",
    BLOCKET = "blocket",
}

export enum Locale {
    NB = "nb",
    DA = "da",
    SV = "sv",
    EN = "en",
}

export enum Subvertical {
    Car = "car",
    Mc = "mc",
    B2B = "b2b",
    Boat = "boat",
    Caravan = "caravan",
}

export enum Env {
    LOCAL = "local",
    DEV = "dev",
    PROD = "prod",
}

export enum Namespace {
    MOBILITY = "mobility",
    RECOMMERCE = "recommerce",
}

export enum ApiVersion {
    v1 = "v1",
    v2 = "v2",
}
